import { useState, useEffect } from "react";

const Timer24h = ({ createdAt, isVerified }) => {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (isVerified) return; // если уже верифицирован - таймер не нужен

    const createdAtTime = new Date(createdAt).getTime();
    const now = Date.now();
    const twentyFourHours = 1000 * 60 * 60 * 24;

    const diff = createdAtTime + twentyFourHours - now;

    if (diff <= 0) {
      setTimeLeft(0);
      return;
    } else {
      setTimeLeft(diff);
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1000) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1000;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [createdAt, isVerified]);

  if (!createdAt || isVerified || timeLeft <= 0) return null;

  const hours = Math.floor(timeLeft / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  return (
    <div className="timer">
      Доступ открыт на 24 часа
      <span className={`timer__time`}>
        {hours}:{minutes}:{seconds}
      </span>
    </div>
  );
};

export default Timer24h;
